<template>
    <div class="modal fade" id="modal-delete-relation-type">
        <div class="modal-dialog" style="max-width: 550px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Delete Relation Type?</h4>
                </div>
                <div class="modal-body" v-if="relationHasProducts">
                    <div v-if="uiStates.errorMessage" class="alert alert-danger ks-solid-light" role="alert">
                        {{ uiStates.errorMessage }}
                    </div>
                    <p>This relation is attached to <span v-if="$refs.vuetable">{{tableRowCount}}</span> product(s). Deleting this relation will also remove the product relations listed below.</p>
                    <hr>
                    <div class="position-relative">
                        <transition name="vue-table-loader">
                            <div class="vue-table-loader alt"v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
                        </transition>
                        <div class="row">
                            <div class="col-md-6">
                                <base-filter-bar placeholder="Search Products"></base-filter-bar>
                            </div>
                            <div class="col-md-6">
                                <base-pagination-info
                                    :css="css.table"
                                    ref="paginationInfo"
                                >
                                </base-pagination-info>
                            </div>
                        </div>
                        <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                            <vuetable ref="vuetable"
                                :api-url="grid"
                                :fields="fields"
                                :css="css.table"
                                :per-page="perPage"
                                :append-params="moreParams"
                                noDataTemplate="No Products Found"
                                pagination-path=""
                                @vuetable:pagination-data="onPaginationData"
                                @vuetable:loaded="onLoaded"
                            >
                                <template slot="actions" slot-scope="props">
                                        <a target="_blank" class="btn btn-outline-primary" :href="'/products/' + props.rowData.id + '/edit/'">View</a>
                                </template>

                            </vuetable>
                            <div class="row">
                                <div class="col-md-12">
                                    <base-pagination  ref="pagination"
                                      @vuetable-pagination:change-page="onChangePage"
                                    ></base-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-body" v-else>
                    Are you sure you want to delete the relation type?
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" v-on:click="deleteRelationType(relationTypeId)">Delete Relation</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.actions {
    margin-bottom: 15px;
}
</style>

<script type="text/javascript">
var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import VueEvents from "vue-events";
import axios from "axios";
import BaseFilterBar from "./base-filter-bar.vue";
import BasePagination from "./base-pagination.vue";
import BasePaginationInfo from "./base-pagination-info.vue";
import BaseSelectVisible from "./base-select-visible.vue";

Vue.use(VueEvents);

export default {
    name: "modal-deletion-listing",
    props: ["listingTarget", "relationProductCount", "relationId", "context"],
    components: {
        "base-filter-bar": BaseFilterBar,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "base-select-visible": BaseSelectVisible
    },
    data() {
        return {
            uiStates: {
                errorMessage: null
            },
            vuetable: this.$refs.vuetable,
            relationHasProducts: this.relationProductCount,
            relationTypeId: this.relationId,
            perPage: 10,
            moreParams: {},
            selected: null,
            loading: true,
            fields: [
                {
                    name: "name",
                    title: "Name",
                    sortField: "name"
                },
                {
                    name: "__slot:actions",
                    titleClass: "actions-single-column"
                }
            ],
            amountsShown: [
                { text: "10", value: 10 },
                { text: "25", value: 25 },
                { text: "50", value: 50 },
                { text: "100", value: 100 }
            ],
            grid: base_url + this.listingTarget,
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: "pull-right"
                }
            }
        };
    },
    mounted() {
        this.$events.$on("per-page", eventData => this.doVisibleSet(eventData));
        this.$events.$on("filter-set", eventData =>
            this.onFilterSet(eventData)
        );
        this.$events.$on("filter-reset", e => this.onFilterReset());
    },
    watch: {
        perPage(val, oldVal) {
            this.$nextTick(function() {
                this.$refs.vuetable.refresh();
            });
        }
    },
    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        editRow(rowData) {
            console.log(rowData);
        },
        deleteRelationType(id) {
            if (this.context == "product") {
                axios
                    .post("/product-relation-types/delete", {
                        id: this.relationTypeId
                    })
                    .then(
                        function(response) {
                            window.location.href = response.data;
                        }.bind(this)
                    )
                    .catch(
                        function(error) {
                            console.log(error);
                            this.uiStates.errorMessage = error.data;
                        }.bind(this)
                    );
            } else if (this.context == "entity") {
                axios
                    .delete(
                        "/pimapi/concrete-entity-related-types/" +
                            this.relationTypeId
                    )
                    .then(
                        function(response) {
                            console.log(response);
                            window.location.href =
                                base_url + "/entity-relation-types";
                        }.bind(this)
                    )
                    .catch(
                        function(error) {
                            console.log(error);
                            this.uiStates.errorMessage = error.data;
                        }.bind(this)
                    );
            }
        },
        doVisibleSet(perPageValue) {
            this.perPage = perPageValue;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterSet(filterText) {
            this.moreParams = {
                filter: filterText
            };
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset() {
            this.moreParams = {};
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onLoaded: function() {
            this.loading = false;
        }
    },
    computed: {
        tableRowCount: function() {
            return this.$refs.vuetable.tableData
                ? this.$refs.vuetable.tableData.length
                : 0;
        }
    }
};
</script>
